function imageZoom() {
    var img, lens, result, ar;
    var cx, cy;
    
    img = $('.lazyload__image-wrapper:not(.hide) .zoom-image');
    if (img.length > 0) {
        var x = setInterval(function () {
            result = $('.lazyload__image-wrapper:not(.hide) .img-zoom-result');
            var imgRealWidth = 0;
            
            // Dynamically load the image and get its real width
            var imgSrc = img.attr('data-custom-zoom');
            var imgObject = new Image();
            imgObject.src = imgSrc;

            // Once the image is loaded, set imgRealWidth
            $(imgObject).on('load', function () {
                imgRealWidth = imgObject.width;

                // Proceed with the rest of the zoom functionality if imgRealWidth is available
                result.css('height', result.outerWidth());
                if (imgRealWidth > 0 && img.outerWidth() > 0) {
                    var lensRatio = imgRealWidth / img.outerWidth();
                    lens = $('.lazyload__image-wrapper:not(.hide) .img-zoom-lens');
                    var lensSize = img.outerWidth() / lensRatio;

                    console.log(imgRealWidth, lensRatio, lensSize);

                    lens.css('height', lensSize).css('width', lensSize);

                    /* calculate the ratio between result DIV and lens: */
                    cx = result.outerWidth() / lensSize;
                    cy = result.outerHeight() / lensSize;

                    /* set background properties for the result DIV: */
                    result.css('background-image', "url('" + img.attr('data-custom-zoom') + "')");
                    result.css('background-size', (img.outerWidth() * cx) + "px " + (img.outerHeight() * cy) + "px");
                    lens.css('background-image', "url('" + img.attr('src') + "')");
                    lens.css('background-size', img.outerWidth() + "px " + img.outerHeight() + "px");

                    /* execute a function when someone moves the cursor over the image, or the lens: */
                    lens.on("mousemove", moveLens);
                    img.on("mousemove", moveLens);
                    /* and also for touch screens: */
                    lens.on("touchmove", moveLens);
                    img.on("touchmove", moveLens);

                    /* removing hover effect on mobile */
                    lens.on("touchstart", function() { $('body').addClass('zoomStart') });
                    img.on("touchstart", function() { $('body').addClass('zoomStart') });
                    lens.on("touchend", function() { $('body').removeClass('zoomStart') });
                    img.on("touchend", function() { $('body').removeClass('zoomStart') });

                    function moveLens(e) {
                        var pos, x, y;
                        e.preventDefault();
                        pos = getCursorPos(e);
                        x = pos.x - (lensSize / 2);
                        y = pos.y - (lensSize / 2);
                        if (x > img.outerWidth() - lensSize) { x = img.outerWidth() - lensSize; }
                        if (x < 0) { x = 0; }
                        if (y > img.outerHeight() - lensSize) { y = img.outerHeight() - lensSize; }
                        if (y < 0) { y = 0; }

                        lens.css('left', x + "px");
                        lens.css('top', y + "px");

                        result.css('background-position', "-" + (x * cx) + "px -" + (y * cy) + "px");
                        result.css('left', (x - result.outerWidth() / 2));
                        result.css('top', + (y - result.outerHeight() - 10) + "px");
                        lens.css('background-position', "-" + x + "px -" + y + "px");
                    }

                    function getCursorPos(e) {
                        e = e || window.event;
                        if (e.originalEvent.touches) {
                            e = e.originalEvent.touches[0];
                        }
                        var a, x = 0, y = 0;
                        a = img[0].getBoundingClientRect();
                        x = e.pageX - a.left;
                        y = e.pageY - a.top;
                        x = x - window.pageXOffset;
                        y = y - window.pageYOffset;
                        return { x: x, y: y };
                    }
                    clearInterval(x);
                }
            });
        }, 200);
    }
}

function filterFunctions(){
function updateURL() {

    console.log('updateURL');
  $('.loader').addClass('loading');
    
    // Serialize the form data
    var formData = $('#collection-filters-sidebar-form').serialize();

    // Construct the new URL with the serialized data
    var newUrl = window.location.pathname;
if(formData){
  newUrl = newUrl + '?' + formData + '&sort_by=' + $('#sortBy').val();
}
  else{
     newUrl = newUrl + '?sort_by=' + $('#sortBy').val();
  }
    // Update the browser's URL
    window.history.replaceState(null, null, newUrl);

    var urlToGet = newUrl + '&section_id=collection-template';
    console.log('urlToGet: ', urlToGet);

    $.get(urlToGet, function(data) {
        // Log the entire data to see its structure
        console.log('Received data: ', data);
        
        // Make sure data is a jQuery object before finding the target element
        var htmlContent = $('<div>').append($.parseHTML(data)).find('#shopify-section-collection-template').html();

        console.log('Extracted htmlContent: ', htmlContent);

        // Replace the content of #shopify-section-collection-template
        if (htmlContent) {
            $('#shopify-section-collection-template').html(htmlContent);

  $('.loader').removeClass('loading').addClass('loaded');
          setTimeout(function(){
  $('.loader').addClass('remove-loaded').removeClass('loaded');
          }, 1000);
          
          if($(window).width() < 768){
          $('html, body').animate({
    scrollTop: $('.products-holder').offset().top - 60
}, 150); 
          }
        } else {
            console.error('Element #shopify-section-collection-template not found in the response.');
        }
    });
}

  
   var $priceRange = $('.price-range');
    var $rangeLowerBound = $priceRange.find('.price-range__range-group input:first-child');
    var $rangeHigherBound = $priceRange.find('.price-range__range-group input:last-child');
    var $textInputLowerBound = $priceRange.find('.price-range__input:first-child input');
    var $textInputHigherBound = $priceRange.find('.price-range__input:last-child input');

    // Select whole text on focus for text field to improve user experience
    $textInputLowerBound.on('focus', function() {
        $(this).select();
    });

    $textInputHigherBound.on('focus', function() {
        $(this).select();
    });

    // Keep in sync the range with the text input fields
    $textInputLowerBound.on('change', function() {
        var newValue = Math.max(Math.min(parseInt($(this).val()), parseInt($textInputHigherBound.val() || this.max) - 1), this.min);
        $(this).val(newValue);
        $rangeLowerBound.val(newValue);
        $rangeLowerBound.parent().css('--range-min', (newValue / $rangeLowerBound.attr('max')) * 100 + '%');
    });

    $textInputHigherBound.on('change', function() {
        var newValue = Math.min(Math.max(parseInt($(this).val()), parseInt($textInputLowerBound.val() || this.min) + 1), this.max);
        $(this).val(newValue);
        $rangeHigherBound.val(newValue);
        $rangeHigherBound.parent().css('--range-max', (newValue / $rangeHigherBound.attr('max')) * 100 + '%');
    });

    $rangeLowerBound.on('change', function() {
        $textInputLowerBound.val($(this).val()).trigger('change');
    });

    $rangeHigherBound.on('change', function() {
        $textInputHigherBound.val($(this).val()).trigger('change');
    });

    // Bound the two range sliders
    $rangeLowerBound.on('input', function() {
        var newValue = Math.min(parseInt($(this).val()), parseInt($textInputHigherBound.val() || this.max) - 1);
        $(this).val(newValue);
        $(this).parent().css('--range-min', (newValue / $(this).attr('max')) * 100 + '%');
        $textInputLowerBound.val(newValue);
    });

    $rangeHigherBound.on('input', function() {
        var newValue = Math.max(parseInt($(this).val()), parseInt($textInputLowerBound.val() || this.min) + 1);
        $(this).val(newValue);
        $(this).parent().css('--range-max', (newValue / $(this).attr('max')) * 100 + '%');
        $textInputHigherBound.val(newValue);
    });
  
   $(document).on('change','#collection-filters-sidebar-form input', function() {
     console.log('form changed');
        updateURL();
    });
  
   $(document).on('change','#sortBy', function() {
     console.log('form changed');
        updateURL();
    });
}

$(document).ready(function(){
  $('html').addClass('zoomReady');
    
    if($(window).width() > 768){
      setTimeout(function(){ 
        
        imageZoom();
      },600);
      
    $('.product-photo-thumb').click(function(){
      setTimeout(function(){ imageZoom(); }, 600);
    })
    }
    else{
     console.log('small screen, no need for that'); 
    }

  filterFunctions();
})